(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-tabs-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function px(v) { return parseFloat(v) || 0; }

    function setupCarousel(carousel) {
      var track = carousel.querySelector('[data-nt-track]');
      if (!track) return;
      var prev = carousel.querySelector('.nordic-tabs__arrow--prev');
      var next = carousel.querySelector('.nordic-tabs__arrow--next');

      function stepAmount() {
        var card = track.querySelector('.nordic-tabs__card');
        var styles = getComputedStyle(track);
        var gap = px(styles.columnGap) || px(styles.gap);
        if (card) {
          var unit = card.offsetWidth + gap;
          var perView = Math.max(1, Math.floor((track.clientWidth + gap) / unit));
          return unit * perView;
        }
        return track.clientWidth * 0.85;
      }

      function refresh() {
        var overflow = (track.scrollWidth - track.clientWidth) > 2;
        carousel.classList.toggle('nt-has-overflow', overflow);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 2);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -stepAmount(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: stepAmount(), behavior: 'smooth' });
        });
      }

      var ticking;
      track.addEventListener('scroll', function () {
        if (ticking) cancelAnimationFrame(ticking);
        ticking = requestAnimationFrame(refresh);
      }, { passive: true });

      carousel._ntRefresh = refresh;
      refresh();
    }

    function refreshWithin(el) {
      el.querySelectorAll('.nordic-tabs__carousel').forEach(function (c) {
        if (typeof c._ntRefresh === 'function') c._ntRefresh();
      });
    }

    function initTabs(root) {
      var tabs = root.querySelectorAll('[data-tab-target]');
      var panels = root.querySelectorAll('.nordic-tabs__panel');

      root.querySelectorAll('.nordic-tabs__carousel').forEach(setupCarousel);

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('data-tab-target');

          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            var match = panel.id === targetId;
            panel.classList.toggle('is-active', match);
            if (match) {
              panel.removeAttribute('hidden');
              refreshWithin(panel);
            } else {
              panel.setAttribute('hidden', '');
            }
          });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-nordic-tabs]').forEach(initTabs);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    window.addEventListener('load', function () {
      document.querySelectorAll('[data-nordic-tabs]').forEach(refreshWithin);
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-nordic-tabs]').forEach(refreshWithin);
    });

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-nordic-tabs]');
      if (root) {
        initTabs(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pisos-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initInfo(root) {
      var tabs = root.querySelectorAll('[data-ni-tab]');
      var panels = root.querySelectorAll('[data-ni-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-ni-tab');
          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var match = p.getAttribute('data-ni-panel') === target;
            p.classList.toggle('is-active', match);
            if (match) {
              p.removeAttribute('hidden');
            } else {
              p.setAttribute('hidden', '');
            }
          });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-nordic-info]').forEach(initInfo);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-nordic-info]');
      if (root) {
        initInfo(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
